import { gql } from '@apollo/client';
import { PLAYER_INFO_FRAGMENT, PLAYER_STATS_FRAGMENT } from '../../fragments';

export const GET_PLAYER_EXPORT_INFO = gql`
  ${PLAYER_STATS_FRAGMENT}
  ${PLAYER_INFO_FRAGMENT}
  query GetStats($leagues: [leagues_enum!]) {
    careerStats(where: { seasonBySeason: { league: { _in: $leagues } } }) {
      ...PlayerStats
      draftRound
      playerByPlayer {
        ...PlayerInfo
        contact
        email
        gbhpc
        lastSeason
      }
      seasonBySeason {
        id
        year
        season
      }
      teamByTeam {
        id
        name
        color
        colorSecondary
        champion
      }
    }
  }
`;
